import RelacaoClientes from './RelacaoClientes'

export default function RelacaoCompradores() {
  return <RelacaoClientes tipo="compradores" titulo="Relação de Compradores" tituloRelatorio="RELAÇÃO DE COMPRADORES" />
}
